$(function(){
setTimeout(function(){

// TOP 
  /* SALE*/
  $('.top-collection-005, .top-collection-002, .top-collection-003, .top-collection-004').removeClass('active').css('display', 'none');
  $('.top-collection-001').addClass('active');
  $('.top-collection-001').css('display', 'block');
  
  $('.collection-001').click(function() {
  	$('.top-collection-001').css('display','block');
  	$('.top-collection-002').css('display','none');
  	$('.top-collection-003').css('display','none');
  	$('.top-collection-004').css('display','none');
  	$('.top-collection-005').css('display','none');
  	$('.collection-001').addClass('active');
  	$('.collection-002').removeClass('active');
  	$('.collection-003').removeClass('active');
  	$('.collection-004').removeClass('active');
  	$('.collection-005').removeClass('active');
  });
  $('.collection-002').click(function() {
  	$('.top-collection-001').css('display','none');
  	$('.top-collection-002').css('display','block');
  	$('.top-collection-003').css('display','none');
  	$('.top-collection-004').css('display','none');
  	$('.top-collection-005').css('display','none');
  	$('.collection-001').removeClass('active');
  	$('.collection-002').addClass('active');
  	$('.collection-003').removeClass('active');
  	$('.collection-004').removeClass('active');
  	$('.collection-005').removeClass('active');
  });
  $('.collection-003').click(function() {
  	$('.top-collection-001').css('display','none');
  	$('.top-collection-002').css('display','none');
  	$('.top-collection-003').css('display','block');
  	$('.top-collection-004').css('display','none');
  	$('.top-collection-005').css('display','none');
  	$('.collection-001').removeClass('active');
  	$('.collection-002').removeClass('active');
  	$('.collection-003').addClass('active');
  	$('.collection-004').removeClass('active');
  	$('.collection-005').removeClass('active');
  });
  $('.collection-004').click(function() {
  	$('.top-collection-001').css('display','none');
  	$('.top-collection-002').css('display','none');
  	$('.top-collection-003').css('display','none');
  	$('.top-collection-004').css('display','block');
  	$('.top-collection-005').css('display','none');
  	$('.collection-001').removeClass('active');
  	$('.collection-002').removeClass('active');
  	$('.collection-003').removeClass('active');
  	$('.collection-004').addClass('active');
  	$('.collection-005').removeClass('active');
  });
  $('.collection-005').click(function() {
  	$('.top-collection-001').css('display','none');
  	$('.top-collection-002').css('display','none');
  	$('.top-collection-003').css('display','none');
  	$('.top-collection-004').css('display','none');
  	$('.top-collection-005').css('display','block');
  	$('.collection-001').removeClass('active');
  	$('.collection-002').removeClass('active');
  	$('.collection-003').removeClass('active');
  	$('.collection-004').removeClass('active');
  	$('.collection-005').addClass('active');
  });

/*
  $('.top-collection-001').addClass('active');
  $('.top-collection-002').removeClass('active');
  $('.top-collection-003').removeClass('active');
  $('.top-collection-004').removeClass('active');
  $('.top-collection-001').css('display','block');
  $('.top-collection-002').css('display','none');
  $('.top-collection-003').css('display','none');
  $('.top-collection-004').css('display','none');
  
  $('.collection-001').click(function() {
  	$('.top-collection-001').css('display','block');
  	$('.top-collection-002').css('display','none');
  	$('.top-collection-003').css('display','none');
  	$('.top-collection-004').css('display','none');
  	$('.collection-001').addClass('active');
  	$('.collection-002').removeClass('active');
  	$('.collection-003').removeClass('active');
  	$('.collection-004').removeClass('active');
  });
  $('.collection-002').click(function() {
  	$('.top-collection-001').css('display','none');
  	$('.top-collection-002').css('display','block');
  	$('.top-collection-003').css('display','none');
  	$('.top-collection-004').css('display','none');
  	$('.collection-001').removeClass('active');
  	$('.collection-002').addClass('active');
  	$('.collection-003').removeClass('active');
  	$('.collection-004').removeClass('active');
  });
  $('.collection-003').click(function() {
  	$('.top-collection-001').css('display','none');
  	$('.top-collection-002').css('display','none');
  	$('.top-collection-003').css('display','block');
  	$('.top-collection-004').css('display','none');
  	$('.collection-001').removeClass('active');
  	$('.collection-002').removeClass('active');
  	$('.collection-003').addClass('active');
  	$('.collection-004').removeClass('active');
  });
  $('.collection-004').click(function() {
  	$('.top-collection-001').css('display','none');
  	$('.top-collection-002').css('display','none');
  	$('.top-collection-003').css('display','none');
  	$('.top-collection-004').css('display','block');
  	$('.collection-001').removeClass('active');
  	$('.collection-002').removeClass('active');
  	$('.collection-003').removeClass('active');
  	$('.collection-004').addClass('active');
  });
*/

  
//COLLECTION

/* FILTER */  
  $('.popout--group .popout__toggle').click(function() {
	  if($('.collection__sidebar__slider').hasClass('expanded')){
        $('.collection-filter-open').css('display','none');
        $('.collection-filter-close').css('display','inline-block');
	  } else {
        $('.collection-filter-open').css('display','inline-block');
        $('.collection-filter-close').css('display','none');
	  }
  });
  
/* SORT */
  $('.popout--sort .popout__toggle').click(function() {
	  $('.collection__sidebar__slider').removeClass('expanded');
	  if($('#sort-list').hasClass('popout-list--visible')){
        $('.collection-sort-open').css('display','none');
        $('.collection-sort-close').css('display','inline-block');
	  } else {
        $('.collection-sort-open').css('display','inline-block');
        $('.collection-sort-close').css('display','none');
	  }
  });  
  
/* SCALE */  
  $('.popout--scale .popout_scale__toggle').click(function() {
	  if($('.product-item').hasClass('large-up--one-quarter')){
        $('.popout--scale').addClass('scalex2');
        $('.collection-scale-open').css('display','none');
        $('.collection-scale-close').css('display','inline-block');
        $('.product-item').removeClass('large-up--one-quarter');
        $('.product-item').addClass('large-up--one-third');
	  } else {
        $('.popout--scale').removeClass('scalex2');
        $('.collection-scale-open').css('display','inline-block');
        $('.collection-scale-close').css('display','none');        
        $('.product-item').addClass('large-up--one-quarter');
        $('.product-item').removeClass('large-up--one-third');
	  }
  });

  
/* HOVER:COLOR SWATCH */
function swatchhover() {
  $('.product-link').on({
    'mouseenter': function() {
    	$(this).children('.product__grid__colorswatch').css('opacity','1');
    },
    'mouseleave': function() {
    	$(this).children('.product__grid__colorswatch').css('opacity','0');
    },
    'touchstart': function() {
    	$(this).children('.product__grid__colorswatch').css('opacity','1');
    },
    'touchend': function() {
    	$(this).children('.product__grid__colorswatch').css('opacity','0');
    }
    
  });
}
swatchhover();
$('.collection__sidebar a').on('click',function(){
setTimeout(function(){
		location.reload();
},800);
});
$('.collection__sidebar input').on('click',function(){
setTimeout(function(){
		location.reload();
},800);
});
$('.popout-list').on('click',function(){
setTimeout(function(){
		location.reload();
},800);
});
  
  
  
},200);
});
